import fileUpload from '@/components/hr-field-upload-validations';
import docSignature from '@/components/hr-field-signature-validations';

const types = {
  UNDEFINED: false,
  STRING: 'stringValue',
  EMAIL: 'stringValue',
  PASSWORD: 'stringValue',
  PASSWORD_SIMPLE: 'stringValue',
  PASSWORD_COMPLEX: 'stringValue',
  NUMBER: 'stringValue',
  E164_PHONE: 'mobileValue',
  LINK: 'stringValue',
  LINK_BUTTON: 'stringValue',
  SELECT: 'stringValue',
  RADIO: 'stringValue',
  CHECK: 'boolValue',
  OPTION: 'stringValue',
  REPEATED: 'stringValue',
  DATE_AU: 'stringValue',
  DATE_US: 'stringValue',
  DATE_ISO8601: 'stringValue',
  ADDRESS_AU: 'addressValue',
  ADDRESS_UK: 'addressValue',
  BSB_AU: 'stringValue',
  TFN_AU: 'stringValue',
  SUPERFUND_AU: 'superfundAUValue',
  CUSTOM_QUESTION: 'questionValue',
};

types[fileUpload.type] = fileUpload.valueKey;
types[docSignature.type] = docSignature.valueKey;

export default types;
